import { Expense, ExpenseKindEnum, SubscriptionTypeEnum } from "@finway-group/shared/lib/models"
import { Skeleton } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { useExpense } from "../../../../../shared/queries/expenses/expense.queries"

interface SubscriptionFieldProps {
    expense: Expense
}

export const SubscriptionField = ({ expense }: SubscriptionFieldProps) => {
    const { t } = useTranslation()

    const isChildSubscription =
        expense.kind === ExpenseKindEnum.SUBSCRIPTION && expense.subscriptionType === SubscriptionTypeEnum.RENEWAL_REQUEST && expense.parentSubscription !== undefined
    const { data: parentSubscription, isLoading, isError } = useExpense(expense.parentSubscription, { enabled: isChildSubscription })

    if (!isChildSubscription) {
        return null
    }

    return (
        <li>
            <span className="title">{t("label:subscription")}</span>
            {isLoading ? (
                <Skeleton.Input className="w-100 " size="small" active />
            ) : (
                <span className="text">
                    {!isError && parentSubscription ? <Link to={`/subscriptions/${parentSubscription?.id}`}>{parentSubscription?.name}</Link> : t("label:n/a")}
                </span>
            )}
        </li>
    )
}
